"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var domHelpers = require("../../util/dom-helpers");
var owner_document_1 = require("./owner-document");
function getContainerDimensions(containerNode) {
    var width, height, scroll;
    if (containerNode.tagName === 'BODY') {
        width = window.innerWidth;
        height = window.innerHeight;
        scroll =
            domHelpers.getScrollTop(owner_document_1.ownerDocument(containerNode).documentElement) ||
                domHelpers.getScrollTop(containerNode);
    }
    else {
        (_a = domHelpers.offset(containerNode), width = _a.width, height = _a.height);
        scroll = domHelpers.getScrollTop(containerNode);
    }
    return { width: width, height: height, scroll: scroll };
    var _a;
}
function getTopDelta(top, overlayHeight, container, padding) {
    var containerDimensions = getContainerDimensions(container);
    var containerScroll = containerDimensions.scroll;
    var containerHeight = containerDimensions.height;
    var topEdgeOffset = top - padding - containerScroll;
    var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;
    if (topEdgeOffset < 0) {
        return -topEdgeOffset;
    }
    else if (bottomEdgeOffset > containerHeight) {
        return containerHeight - bottomEdgeOffset;
    }
    else {
        return 0;
    }
}
function getLeftDelta(left, overlayWidth, container, padding) {
    var containerDimensions = getContainerDimensions(container);
    var containerWidth = containerDimensions.width;
    var leftEdgeOffset = left - padding;
    var rightEdgeOffset = left + padding + overlayWidth;
    if (leftEdgeOffset < 0) {
        return -leftEdgeOffset;
    }
    else if (rightEdgeOffset > containerWidth) {
        return containerWidth - rightEdgeOffset;
    }
    return 0;
}
function calculatePosition(placement, overlayNode, target, container, padding) {
    var childOffset = container.tagName === 'BODY' ?
        domHelpers.offset(target) : domHelpers.position(target, container);
    var _a = domHelpers.offset(overlayNode), overlayHeight = _a.height, overlayWidth = _a.width;
    var positionLeft;
    var positionTop;
    var arrowOffsetLeft;
    var arrowOffsetTop;
    if (placement === 'left' || placement === 'right') {
        positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;
        if (placement === 'left') {
            positionLeft = childOffset.left - overlayWidth;
        }
        else {
            positionLeft = childOffset.left + childOffset.width;
        }
        var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);
        positionTop = positionTop + topDelta;
        arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
        arrowOffsetLeft = void 0;
    }
    else if (placement === 'top' || placement === 'bottom') {
        positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;
        if (placement === 'top') {
            positionTop = childOffset.top - overlayHeight;
        }
        else {
            positionTop = childOffset.top + childOffset.height;
        }
        var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);
        positionLeft = positionLeft + leftDelta;
        arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
        arrowOffsetTop = void 0;
    }
    else {
        throw new Error("calcOverlayPosition(): No such placement of \"" + placement + "\" found.");
    }
    return {
        positionLeft: positionLeft,
        positionTop: positionTop,
        arrowOffsetLeft: arrowOffsetLeft,
        arrowOffsetTop: arrowOffsetTop
    };
}
exports.calculatePosition = calculatePosition;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/react-overlays/utils/calculate-position.js
// module id = 481
// module chunks = 0 1 2 3 4 5 6